<template>
  <div>
    <div class="form-group">
      <label class="mb-2">Saya BISA mengirimkan produk ke alamat penerimaan pembeli</label>
      <div class="form-check form-check-inline">
        <input class="form-check-input"
               required="required"
               type="radio"
               value="true"
               name="product_self_shipping"
               v-model="selfShipping"
               id="product_self_shipping_true" />
        <label class="form-check-label" for="Ya_true">Ya</label>
      </div>
      <div class="form-check form-check-inline">
        <input class="form-check-input"
               required="required"
               type="radio"
               value="false"
               name="product_self_shipping"
               v-model="selfShipping"
               id="product_self_shipping_false" />
        <label class="form-check-label" for="Tidak_false">Tidak</label>
      </div>
    </div>
    <div v-show="showAdditionalAttribute" class="form-group">
      <label>Estimasi ongkos kirim terendah</label>
      <money-field input-name="product_min_estimation_shipping_cost" :cookies="productMinEstimationShippingCost"></money-field>
    </div>
    <div v-show="showAdditionalAttribute" class="form-group">
      <label>Estimasi ongkos kirim tertinggi</label>
      <money-field input-name="product_max_estimation_shipping_cost" :cookies="productMaxEstimationShippingCost"></money-field>
    </div>
    <div v-show="showAdditionalAttribute" class="form-group">
      <label>Catatan pengiriman</label>
      <textarea class="form-control"
                placeholder="Contoh: Produk sampai di alamat tujuan khusus dalam kota. Atau hanya sampai di stasiun/terminal untuk kemudian dijemput oleh pembeli."
                name="product_self_shipping_note"
                id="product_self_shipping_note"
                v-model="selfShippingNote">
      </textarea>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CreateProductStep4',
  data(){
    return {
      selfShipping: 'true',
      selfShippingNote: ''
    }
  },
  props: {
    productSelfShipping: {
      type: String,
      default: 'true'
    },
    productMinEstimationShippingCost: {
      type: String,
      default: ''
    },
    productMaxEstimationShippingCost: {
      type: String,
      default: ''
    },
    productSelfShippingNote: {
      type: String,
      default: ''
    }
  },
  computed: {
    showAdditionalAttribute(){
      return this.selfShipping === 'true'
    }
  },
  mounted(){
    this.selfShipping = this.productSelfShipping
    this.selfShippingNote = this.productSelfShippingNote
  }
}
</script>